export default {
    isGridOpen: state => state.gridIsOpen,
    isFormOpen: state => state.formIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchHeaderFields
}
